export default function ActionsIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_4565_6387'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_4565_6387)'>
        <path
          d='M10.5511 18.2036L15.7261 12.0036H11.7261L12.4511 6.32863L7.82612 13.0036H11.3011L10.5511 18.2036ZM8.57812 21.4459L9.57812 14.5036H4.95312L13.1934 2.60938H14.4241L13.4339 10.5036H18.9336L9.80888 21.4459H8.57812Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
}
